// @unocss-include

import { primaryColor, colorGreenSoft } from '@/styles/variables.module.scss'

export const modelNames = [
  {
    label: 'DeepSeek',
    value: 'deepseek',
    i18Key: 'common.aiModel.deepseek',
    icon: 'https://aiciting-cn.oss-cn-hangzhou.aliyuncs.com/abroad/officialSite/deepseek.jpeg'
  },
  {
    label: '豆包',
    value: 'doubao',
    i18Key: 'common.aiModel.doubao',
    icon: 'https://aiciting-cn.oss-cn-hangzhou.aliyuncs.com/abroad/officialSite/doubao.png'
  },
  {
    label: 'Kimi',
    value: 'kimi',
    i18Key: 'common.aiModel.kimi',
    icon: 'https://aiciting-cn.oss-cn-hangzhou.aliyuncs.com/abroad/officialSite/kimi.png'
  },
  {
    label: '夸克',
    value: 'kuake',
    i18Key: 'common.aiModel.kuake',
    icon: 'https://aiciting-cn.oss-cn-hangzhou.aliyuncs.com/abroad/officialSite/kuake.png'
  },
  {
    label: '千问',
    value: 'tongyi',
    i18Key: 'common.aiModel.tongyi',
    icon: 'https://aiciting-cn.oss-cn-hangzhou.aliyuncs.com/abroad/officialSite/tongyi.png'
  },
  {
    label: '文心一言',
    value: 'wenxinyiyan',
    i18Key: 'common.aiModel.wenxinyiyan',
    icon: 'https://aiciting-cn.oss-cn-hangzhou.aliyuncs.com/abroad/officialSite/wenxinyiyan.png',
    status: 2,
    hidden: true
  },
  {
    label: '百度AI',
    value: 'baiduai',
    i18Key: 'common.aiModel.baiduai',
    icon: 'https://aiciting-cn.oss-cn-hangzhou.aliyuncs.com/abroad/officialSite/baiduai.png'
  },
  {
    label: '元宝',
    value: 'yuanbao',
    i18Key: 'common.aiModel.yuanbao',
    icon: 'https://aiciting-cn.oss-cn-hangzhou.aliyuncs.com/abroad/officialSite/yuanbao.png'
  },
  {
    label: '百川',
    value: 'baichuan',
    i18Key: 'common.aiModel.baichuan',
    icon: 'https://aiciting-cn.oss-cn-hangzhou.aliyuncs.com/abroad/officialSite/baichuan.png',
    status: 2
  },
  {
    label: 'ChatGPT',
    value: 'chatgpt',
    i18Key: 'common.aiModel.chatgpt',
    icon: 'https://aiciting-cn.oss-cn-hangzhou.aliyuncs.com/abroad/officialSite/chatgpt.jpeg',
    status: 2
  },
  {
    label: 'Gemini',
    value: 'gemini',
    i18Key: 'common.aiModel.gemini',
    icon: 'https://aiciting-cn.oss-cn-hangzhou.aliyuncs.com/abroad/officialSite/gemini.png',
    status: 2
  },
  {
    label: 'Claude',
    value: 'claude',
    i18Key: 'common.aiModel.claude',
    icon: 'https://aiciting-cn.oss-cn-hangzhou.aliyuncs.com/abroad/officialSite/claude.png',
    status: 2
  },
  {
    label: 'Grok',
    value: 'grok',
    i18Key: 'common.aiModel.grok',
    icon: 'https://aiciting-cn.oss-cn-hangzhou.aliyuncs.com/abroad/officialSite/grok.png',
    status: 2
  },
  {
    label: 'Perplexity',
    value: 'perplexity',
    i18Key: 'common.aiModel.perplexity',
    icon: 'https://aiciting-cn.oss-cn-hangzhou.aliyuncs.com/abroad/officialSite/sonar.png',
    status: 2
  },
  {
    label: '秘塔',
    value: 'metaso',
    i18Key: 'common.aiModel.metaso',
    icon: 'https://aiciting-cn.oss-cn-hangzhou.aliyuncs.com/abroad/officialSite/metaso.png',
    status: 2
  },
  {
    label: '小红书（点点）',
    value: 'rebeka',
    i18Key: 'common.aiModel.rebeka',
    icon: 'https://aiciting-cn.oss-cn-hangzhou.aliyuncs.com/abroad/officialSite/rebeka.jpg',
    hidden: true
  },
  {
    label: '阿福',
    value: 'afu',
    i18Key: 'common.aiModel.afu',
    icon: 'https://aiciting-cn.oss-cn-hangzhou.aliyuncs.com/abroad/officialSite/afu.jpg',
    hidden: true
  }
]

export const childModelNames = [
  {
    parent: '',
    value: 'API',
    label: 'API'
  },
  {
    parent: '',
    value: 'App',
    label: 'App'
  },
  {
    parent: 'yuanbao',
    value: 'Hunyuan',
    label: 'Hunyuan'
  },
  {
    parent: 'yuanbao',
    value: 'DeepSeek',
    label: 'DeepSeek'
  },
  {
    parent: 'kimi',
    value: 'K1.5',
    label: 'K1.5'
  },
  {
    parent: 'kimi',
    value: 'K2',
    label: 'K2'
  },
  {
    parent: 'kimi',
    value: 'K2.5-Instant',
    label: 'K2.5-Instant'
  },
  {
    parent: 'kimi',
    value: 'K2.5-Thinking',
    label: 'K2.5-Thinking'
  },
  {
    parent: 'kimi',
    value: 'K2.6-Instant',
    label: 'K2.6-Instant'
  },
  {
    parent: 'kimi',
    value: 'K2.6-Thinking',
    label: 'K2.6-Thinking'
  },
  {
    parent: 'baiduai',
    value: 'Lightning',
    label: 'Lightning'
  },
  {
    parent: 'baiduai',
    value: 'DeepSeek-R1',
    label: 'DeepSeek-R1'
  },
  {
    parent: 'baiduai',
    value: 'DeepSeek-V3.2',
    label: 'DeepSeek-V3.2'
  },
  {
    parent: 'baiduai',
    value: 'Wenxin4.5Turbo',
    label: '文心4.5Turbo'
  }
]

export const aiModelTypes = [
  {
    label: 'common.deepThink',
    value: 'deepThink'
  },
  {
    label: 'common.network',
    value: 'network'
  },
  {
    label: 'common.model',
    value: 'model'
  }
]

// task状态
export const taskStatus = [
  'task.common.taskStatus.creating',
  'task.common.taskStatus.notStarted',
  'task.common.taskStatus.fetchingData',
  'task.common.taskStatus.paused',
  'task.common.taskStatus.inProgress',
  'task.common.taskStatus.completed'
]

// 今日task状态
export const todayTaskStatus = ['task.common.todayTaskStatus.queuing', 'task.common.todayTaskStatus.updated']

// 版本名称
export const versionList = [
  {
    label: 'common.version.v1',
    zhLabel: '免费版',
    value: 1
  },
  {
    label: 'common.version.v2',
    zhLabel: '品牌试用版',
    value: 2
  },
  {
    label: 'common.version.v3',
    zhLabel: '品牌专业版',
    value: 3
  },
  {
    label: 'common.version.v4',
    zhLabel: '定制版',
    value: 4
  }
]

export const timeTypes = [
  {
    value: 1,
    label: 'components.timeType.lastDay'
  },
  {
    value: 2,
    label: 'components.timeType.lastWeek'
  },
  {
    value: 3,
    label: 'components.timeType.lastMonth'
  },
  // 自定义
  {
    value: 4,
    label: 'components.timeType.custom'
  }
]

// 分享权限
export const sharePermission = [
  {
    value: 0,
    i18Key: 'projectSharing.index.owner'
  },
  {
    value: 1,
    i18Key: 'projectSharing.index.admin'
  },
  {
    value: 2,
    i18Key: 'projectSharing.index.editable'
  },
  {
    value: 3,
    i18Key: 'projectSharing.index.viewOnly'
  },
  {
    value: 4,
    i18Key: 'projectSharing.index.restricted'
  }
]

// 情感标签枚举
export const sentimentTags = [
  {
    value: -1,
    i18Key: 'sentiment.index.detail.tags.negative',
    color: '#555'
  },
  {
    value: 0,
    i18Key: 'sentiment.index.detail.tags.neutral',
    color: colorGreenSoft
  },
  {
    value: 1,
    i18Key: 'sentiment.index.detail.tags.positive',
    color: primaryColor
  }
]

// 高阶模块枚举
export const advAnalyticsEnum = {
  VisibilityIndex: 1,
  QueryAnalysisIndex: 2,
  SentimentIndex: 4
}

// 文档类型枚举
export const documentType = [
  {
    name: 'PDF',
    value: 'pdf'
  },
  {
    name: 'DOCX',
    value: 'docx'
  },
  {
    name: 'DOC',
    value: 'doc'
  },
  {
    name: 'XLS',
    value: 'xls'
  },
  {
    name: 'XLSX',
    value: 'xlsx'
  },
  {
    name: 'PPTX',
    value: 'pptx'
  },
  {
    name: 'PPT',
    value: 'ppt'
  },
  {
    name: 'TXT',
    value: 'txt'
  },
  {
    name: 'MD',
    value: 'md'
  }
]

// 信源范围筛选：0 全部信源，1 品牌信源
export const sourceFilterList = [
  {
    label: 'sourceContribution.index.result.filter.all',
    value: 0
  },
  {
    label: 'sourceContribution.index.result.filter.brand',
    value: 1
  }
]

// 项目类型 2快速项目 1正常项目
export const projectTypeList = [
  {
    type: 2,
    name: 'project.index.selectProject.quick.name',
    desc: 'project.index.selectProject.quick.desc',
    icon: 'i-self:quick',
    btnText: 'project.index.selectProject.quick.btnText'
  },
  {
    type: 1,
    name: 'project.index.selectProject.tracking.name',
    desc: 'project.index.selectProject.tracking.desc',
    icon: 'i-self:process',
    btnText: 'project.index.selectProject.tracking.btnText'
  },
  {
    type: 3,
    name: 'project.index.selectProject.medical.name',
    desc: 'project.index.selectProject.medical.desc',
    icon: 'i-self:medical',
    btnText: 'project.index.selectProject.medical.btnText'
  }
]
